import CredentialsProvider from 'next-auth/providers/credentials';
import FacebookProvider from "next-auth/providers/facebook";
import axios from "axios";
import Facebook from "next-auth/providers/facebook";
import Google from "next-auth/providers/google";
export const authOptions = {
    session : {
        strategy: 'jwt',
    },
    secret : process.env.AUTH_SECRET,
    providers : [
        CredentialsProvider({
            id: "cwf",
            name: "cwf",
            credentials: {
                email: { label: "Email", type: "email" },
                password: { label: "Password", type: "password" },
            },
            async authorize(credentials){
                try {
                    const res = await axios.post(process.env.API_URL + "login", {
                        email: credentials?.email,
                        password: credentials?.password
                    });

                    return res.data.data;

                } catch (e) {
                    return null;
                }
            },
        }),
        Facebook({
            clientId : "902935941567335",
            clientSecret : "6f3fdb9b6da325db934b956a34bcd70e",
            async profile(profile, tokens){


                /*Je suis ici
                {
                    id: '926500322262748',
                        name: 'Grégory Deneuve',
                    email: 'gregory.deneuve@outlook.fr',
                    picture: {
                    data: {
                        height: 50,
                            is_silhouette: false,
                            url: 'https://platform-lookaside.fbsbx.com/platform/profilepic/?asid=926500322262748&height=50&width=50&ext=1708339879&hash=Afr-2wOR7uCqYG8wYnTLwGLwC8mHEBgw7HNOIwH97iO2LQ',
                            width: 50
                    }
                }*/

                    /*TokenSet {
                        access_token: 'EAAM1NygNU2cBOzvybPFeUsjeUrZBCLfG3FM7ZCfjZA6Uua23nPxhoErJ68aXR8Qhpx8QxrzjZBzNaov8BzlxZCDZCC2bzFebkMZCYEZC8ZCgtP6uGUpK1UatdnznKYpQZCocqQRti39Kp9nTDGpdbBLzvhvKz1abUzEqAldYquxGi4Tb8vmeEr4biZAXDAaTDpepTF9nmiT4NrcYiD
                        pRkgKuzbTtT45iZBM595Jo3yrZBZBtSDqkQPVcCE8epg',
                        token_type: 'bearer',
                            expires_at: 1710864278
                    }*/

            }
        }),
        Google({
            clientId : "199284710422-9uk9sv8v6la05kdtm0svqu42s58q04e2.apps.googleusercontent.com",
            clientSecret : "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",
            async profile(profile, tokens){


            }
        })
    ],
    callbacks : {
        async jwt({token,user}){


            if(user){
                return{
                    ...token,
                    accessToken : user.token,
                    ...user,
                };
            }
            return token;
        },

        async session({session,token}){

            session.user.token = token.token;
            session.user.user = token.user;
            return session;
        },
    },
    debug: process.env.NODE_ENV === 'development'
}
